import { MarketplacePropertyCategory_PropertySearchEvent_Trigger } from '@opendoor/observability/pbs/journey/data/categories/marketplace_property_category_pb';
import type { EventData } from '@opendoor/observability/slim';

import { dollarsToCents } from './money';
import { DEFAULT_LISTING_SORT_SLUG, type ListingSortSlug } from './sortOptions';

export { MarketplacePropertyCategory_PropertySearchEvent_Trigger as PropertySearchTrigger };

export type PropertySearchEventData = EventData<'marketplaceProperty', 'propertySearch'>;

interface PropertySearchFilters {
  /** Minimum bedrooms; 0 or null means unset (matches `useSearchState`'s "Any"). */
  minBeds: number | null;
  /** Minimum bathrooms; 0 or null means unset. */
  minBaths: number | null;
  /** Minimum list price in dollars, as stored by `useSearchState`; null means unset. */
  minPrice: number | null;
  /** Maximum list price in dollars; null means unset. */
  maxPrice: number | null;
}

export interface BuildPropertySearchEventOptions {
  /** The user interaction that ran the search. */
  trigger: MarketplacePropertyCategory_PropertySearchEvent_Trigger;
  /** Filter values in effect for the search. */
  filters: PropertySearchFilters;
  /** Market display name for the page (`marketInfo.name`). */
  market: string | null | undefined;
  /** Total result count for the settled search; null/undefined reports 0. */
  resultsCount: number | null | undefined;
  /** Applied sort; reported only when it differs from the default ordering. */
  sort?: ListingSortSlug | null;
  /** One-based results page the interaction loaded; unset for unpaged searches. */
  page?: number | null;
}

export const buildPropertySearchEvent = ({
  trigger,
  filters,
  market,
  resultsCount,
  sort,
  page,
}: BuildPropertySearchEventOptions): PropertySearchEventData => ({
  trigger,
  ...(market ? { market } : {}),
  resultsCount: resultsCount ?? 0,
  ...(page != null && page > 0 ? { page } : {}),
  ...(sort != null && sort !== DEFAULT_LISTING_SORT_SLUG ? { sort } : {}),
  ...(filters.minBeds ? { minBeds: filters.minBeds } : {}),
  ...(filters.minBaths ? { minBaths: filters.minBaths } : {}),
  ...(filters.minPrice != null
    ? { minPriceCents: BigInt(Math.round(dollarsToCents(filters.minPrice))) }
    : {}),
  ...(filters.maxPrice != null
    ? { maxPriceCents: BigInt(Math.round(dollarsToCents(filters.maxPrice))) }
    : {}),
});
